"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanRendererFactory = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const RosetteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RosetteIcon"));
const ScheduleClockIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ScheduleClockIcon"));
const ScheduleOnDemandIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ScheduleOnDemandIcon"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const BooleanRendererFactory = (viewField) => (item) => {
    const value = (0, get_1.default)(item, viewField.propertyName);
    if (!value)
        return null;
    let icon;
    switch (viewField.icon) {
        case 'ScheduleClockIcon':
            icon = (react_1.default.createElement(ScheduleClockIcon_1.default, { style: { margin: '0 auto' }, size: 24, color: lib_palette_1.default.BlackCoral }));
            break;
        case 'ScheduleUserIcon':
            icon = (react_1.default.createElement(ScheduleOnDemandIcon_1.default, { style: { margin: '0 auto' }, size: 24, color: lib_palette_1.default.BlackCoral }));
            break;
        case 'RosetteIcon':
            icon = react_1.default.createElement(RosetteIcon_1.default, { style: { margin: '0 auto' }, size: 24, color: lib_palette_1.default.BlackCoral });
            break;
        default:
            icon = react_1.default.createElement(CheckIcon_1.default, { style: { margin: '0 auto' }, size: 14 });
    }
    return viewField.iconTip ? react_1.default.createElement(Tooltip_1.default, { tip: viewField.iconTip }, icon) : icon;
};
exports.BooleanRendererFactory = BooleanRendererFactory;
exports.default = exports.BooleanRendererFactory;
